
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8d2f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8d2f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4ACxo", function(module, exports) {

$parcel$export(module.exports, "mastheadTitleScale", () => $35786af7645e33f6$export$a97c8b9e1aa7edd8);
$parcel$export(module.exports, "centeredTitleTransform", () => $35786af7645e33f6$export$23c8cb846febe10);
$parcel$export(module.exports, "workTitleRows", () => $35786af7645e33f6$export$bc08165781f4cf58);
// Shared by the SVG gallery and canvas homepage. CSS owns the size limit.
function $35786af7645e33f6$export$a97c8b9e1aa7edd8(element, cssScale, viewWidth = 1200) {
    const maxWidth = parseFloat(getComputedStyle(element).getPropertyValue('--masthead-title-max-width')) || 960;
    return Math.min(1, maxWidth / (viewWidth * cssScale));
}
function $35786af7645e33f6$export$23c8cb846febe10(scale, x, y) {
    return `translate(${x} ${y}) scale(${scale}) translate(${-x} ${-y})`;
}
function $35786af7645e33f6$export$bc08165781f4cf58(rows, small) {
    const x = small ? 380 : 600;
    const baselines = rows.length === 1 ? [
        small ? 345 : 295
    ] : small ? [
        245,
        410
    ] : [
        205,
        385
    ];
    return rows.map((text, i)=>[
            x,
            baselines[i],
            text
        ]);
}

});

parcelRegister("fkbDJ", function(module, exports) {

$parcel$export(module.exports, "trainingLabels", () => $b281c0b7a3469417$export$867063a90059e7dc);
$parcel$export(module.exports, "trainingGeometry", () => $b281c0b7a3469417$export$405ad9cd4baa45b7);
$parcel$export(module.exports, "arcGeometry", () => $b281c0b7a3469417$export$1e08e05fe8eeb1d9);
$parcel$export(module.exports, "federatedGeometry", () => $b281c0b7a3469417$export$934a6778e8d9d0e9);
$parcel$export(module.exports, "projector", () => $b281c0b7a3469417$export$7073c4a9d7566d2a);
$parcel$export(module.exports, "renderCurves", () => $b281c0b7a3469417$export$9154120554b8ccbd);
// Decorative research geometry shared by the gallery masthead and the studies.
// Coordinates describe the visual composition, not a model's hidden states.
const $b281c0b7a3469417$var$line = (points, extra = {})=>({
        points: points,
        phase: -1,
        ...extra
    });
function $b281c0b7a3469417$var$rectangle(x, y, w, h, z) {
    return [
        [
            x,
            y,
            z
        ],
        [
            x + w,
            y,
            z
        ],
        [
            x + w,
            y + h,
            z
        ],
        [
            x,
            y + h,
            z
        ],
        [
            x,
            y,
            z
        ]
    ];
}
function $b281c0b7a3469417$var$box(x, y, w, h, z, thickness, extra = {}) {
    const front = $b281c0b7a3469417$var$rectangle(x, y, w, h, z);
    const back = $b281c0b7a3469417$var$rectangle(x, y, w, h, z + thickness);
    return [
        $b281c0b7a3469417$var$line(front, extra),
        $b281c0b7a3469417$var$line(back, extra),
        ...front.slice(0, 4).map((p, i)=>$b281c0b7a3469417$var$line([
                p,
                back[i]
            ], extra))
    ];
}
const $b281c0b7a3469417$export$867063a90059e7dc = [
    {
        text: 'DATA',
        point: [
            -375,
            -172,
            5
        ]
    },
    {
        text: 'PRETRAIN',
        point: [
            -95,
            -172,
            -30
        ]
    },
    {
        text: 'SFT',
        point: [
            240,
            -172,
            10
        ]
    },
    {
        text: 'PROMPTS',
        point: [
            -375,
            28,
            35
        ]
    },
    {
        text: 'DiT',
        point: [
            -90,
            28,
            -65
        ]
    },
    {
        text: 'SAMPLES',
        point: [
            240,
            28,
            20
        ]
    },
    {
        text: 'RL',
        point: [
            -90,
            200,
            -10
        ]
    },
    {
        text: 'REWARDS',
        point: [
            235,
            200,
            45
        ]
    }
];
function $b281c0b7a3469417$export$405ad9cd4baa45b7() {
    const curves = [];
    for (const { point: [x, y, z] } of $b281c0b7a3469417$export$867063a90059e7dc){
        const w = 205, h = 104, left = x - w / 2, top = y - 40;
        curves.push(...$b281c0b7a3469417$var$box(left, top, w, h, z, 44));
        for (const d of [
            14,
            28
        ])curves.push($b281c0b7a3469417$var$line($b281c0b7a3469417$var$rectangle(left, top, w, h, z + d)));
        // Leave a clear title band; dense cells form the lower portion.
        for(let col = 0; col <= 9; col++){
            const xx = left + 14 + col * 19.5;
            curves.push($b281c0b7a3469417$var$line([
                [
                    xx,
                    y + 12,
                    z
                ],
                [
                    xx,
                    top + h - 10,
                    z
                ]
            ]));
        }
        for(let row = 0; row <= 3; row++){
            const yy = y + 12 + row * 14;
            curves.push($b281c0b7a3469417$var$line([
                [
                    left + 14,
                    yy,
                    z
                ],
                [
                    left + w - 15,
                    yy,
                    z
                ]
            ]));
        }
    }
    const routes = [
        [
            [
                -270,
                -175,
                5
            ],
            [
                -198,
                -175,
                -30
            ]
        ],
        [
            [
                8,
                -175,
                -30
            ],
            [
                137,
                -175,
                10
            ]
        ],
        [
            [
                240,
                -108,
                10
            ],
            [
                240,
                -80,
                10
            ],
            [
                -90,
                -80,
                -65
            ],
            [
                -90,
                -12,
                -65
            ]
        ],
        [
            [
                -270,
                30,
                35
            ],
            [
                -198,
                30,
                -65
            ]
        ],
        [
            [
                13,
                30,
                -65
            ],
            [
                137,
                30,
                20
            ]
        ],
        [
            [
                240,
                92,
                20
            ],
            [
                240,
                160,
                45
            ]
        ],
        [
            [
                132,
                205,
                45
            ],
            [
                13,
                205,
                -10
            ]
        ],
        [
            [
                -195,
                205,
                -10
            ],
            [
                -240,
                205,
                -10
            ],
            [
                -240,
                90,
                -65
            ],
            [
                -90,
                90,
                -65
            ]
        ]
    ];
    routes.forEach((route, index)=>{
        // A bundle of parallel wires makes the data paths feel substantial.
        for(let lane = -2; lane <= 2; lane++)curves.push($b281c0b7a3469417$var$line(route.map(([x, y, z])=>[
                x,
                y + lane * 5,
                z + lane * 3
            ])));
        curves.push(...$b281c0b7a3469417$var$box(-5, -5, 10, 10, 0, 10, {
            travel: {
                route: route,
                period: 10,
                offset: index * 1.1
            }
        }));
    });
    return curves;
}
function $b281c0b7a3469417$export$1e08e05fe8eeb1d9() {
    const curves = [];
    for(let panel = 0; panel < 2; panel++){
        const left = -415 + panel * 455, top = -172, step = 47;
        // A permanent grid keeps the composition full during arrivals.
        for(let layer = 0; layer < 3; layer++){
            const z = 16 + layer * 13;
            for(let i = 0; i <= 7; i++){
                curves.push($b281c0b7a3469417$var$line([
                    [
                        left + i * step,
                        top,
                        z
                    ],
                    [
                        left + i * step,
                        top + 7 * step,
                        z
                    ]
                ]));
                curves.push($b281c0b7a3469417$var$line([
                    [
                        left,
                        top + i * step,
                        z
                    ],
                    [
                        left + 7 * step,
                        top + i * step,
                        z
                    ]
                ]));
            }
        }
        for(let y = 0; y < 7; y++)for(let x = 0; x < 7; x++){
            const order = panel === 0 ? y * 7 + x : (x * 19 + y * 31) % 49;
            const extra = {
                arrival: order * .055 + panel * .3
            };
            const xx = left + x * step + 3, yy = top + y * step + 3;
            // Every cell face settles at z=0, with identical thickness.
            curves.push(...$b281c0b7a3469417$var$box(xx, yy, 41, 41, 0, 12, extra));
            curves.push($b281c0b7a3469417$var$line($b281c0b7a3469417$var$rectangle(xx + 5, yy + 5, 31, 31, 0), extra));
            curves.push($b281c0b7a3469417$var$line([
                [
                    xx + 20.5,
                    yy + 5,
                    0
                ],
                [
                    xx + 20.5,
                    yy + 36,
                    0
                ]
            ], extra));
            curves.push($b281c0b7a3469417$var$line([
                [
                    xx + 5,
                    yy + 20.5,
                    0
                ],
                [
                    xx + 36,
                    yy + 20.5,
                    0
                ]
            ], extra));
        }
    }
    return curves;
}
function $b281c0b7a3469417$export$934a6778e8d9d0e9() {
    const curves = [];
    for(let i = 0; i < 8; i++){
        const y = -215 + i * 58;
        curves.push(...$b281c0b7a3469417$var$box(-470, y, 28, 42, 0, 9));
        for(let layer = 0; layer < 3; layer++)curves.push(...$b281c0b7a3469417$var$box(-365, y + 4, 58, 36, layer * 12, 0));
        for(let col = 1; col < 4; col++)curves.push($b281c0b7a3469417$var$line([
            [
                -365 + col * 14.5,
                y + 4,
                24
            ],
            [
                -365 + col * 14.5,
                y + 40,
                24
            ]
        ]));
        const route = [
            [
                -300,
                y + 22,
                24
            ],
            [
                -210,
                y + 22,
                35
            ],
            [
                -110,
                0,
                60
            ]
        ];
        curves.push($b281c0b7a3469417$var$line(route));
        for(let packet = 0; packet < 2; packet++)curves.push(...$b281c0b7a3469417$var$box(-9, -9, 18, 18, 0, 12, {
            travel: {
                route: route,
                period: 9,
                offset: i * .75 + packet * 4.5
            }
        }));
    }
    for(let layer = 0; layer < 4; layer++)curves.push(...$b281c0b7a3469417$var$box(-110, -100, 160, 200, layer * 20, 0));
    for(let col = 1; col < 8; col++)curves.push($b281c0b7a3469417$var$line([
        [
            -110 + col * 20,
            -100,
            60
        ],
        [
            -110 + col * 20,
            100,
            60
        ]
    ]));
    for(let row = 1; row < 10; row++)curves.push($b281c0b7a3469417$var$line([
        [
            -110,
            -100 + row * 20,
            60
        ],
        [
            50,
            -100 + row * 20,
            60
        ]
    ]));
    for(let i = 0; i < 3; i++){
        const y = -145 + i * 115;
        const route = [
            [
                50,
                0,
                60
            ],
            [
                115,
                0,
                30
            ],
            [
                155,
                y + 38,
                20
            ]
        ];
        curves.push($b281c0b7a3469417$var$line(route), ...$b281c0b7a3469417$var$box(155, y, 145, 76, 0, 26));
        curves.push(...$b281c0b7a3469417$var$box(-12, -8, 24, 16, 0, 12, {
            travel: {
                route: route,
                period: 6,
                offset: i * 1.5
            }
        }));
        for(let col = 1; col < 5; col++)curves.push($b281c0b7a3469417$var$line([
            [
                155 + col * 29,
                y,
                0
            ],
            [
                155 + col * 29,
                y + 76,
                0
            ]
        ]));
        for(let row = 1; row < 3; row++)curves.push($b281c0b7a3469417$var$line([
            [
                155,
                y + row * 25,
                0
            ],
            [
                300,
                y + row * 25,
                0
            ]
        ]));
        curves.push($b281c0b7a3469417$var$line([
            [
                300,
                y + 38,
                0
            ],
            [
                365,
                y + 38,
                0
            ],
            [
                410,
                0,
                0
            ]
        ]));
    }
    return curves;
}
function $b281c0b7a3469417$export$b64aebf1049813c0(curve, seconds, settled = false) {
    if (curve.arrival !== undefined) {
        if (settled) return [
            0,
            0,
            0
        ];
        const age = seconds % 17 - curve.arrival;
        if (age < 0) return null;
        const z = age >= 3 ? 0 : 280 * Math.exp(-2.7 * age) * (Math.cos(5.8 * age) + .4655 * Math.sin(5.8 * age));
        return [
            0,
            0,
            z
        ];
    }
    if (curve.travel) {
        const { route: route, period: period, offset: offset } = curve.travel;
        const progress = (seconds + offset) % period / period * (route.length - 1);
        const index = Math.min(route.length - 2, Math.floor(progress));
        const fraction = progress - index;
        return route[index].map((value, axis)=>value + (route[index + 1][axis] - value) * fraction);
    }
    return [
        0,
        0,
        0
    ];
}
function $b281c0b7a3469417$export$7073c4a9d7566d2a({ time: time, phase: phase = 0, scale: scale = 1, x: x = 600, y: y = 250, depth: depth = 1 }) {
    const yaw = Math.sin(time * .1 + phase) * .3;
    const pitch = -0.12 + Math.cos(time * .075 + phase) * .13;
    const roll = Math.sin(time * .06 + phase) * .055;
    const cy = Math.cos(yaw), sy = Math.sin(yaw), cx = Math.cos(pitch), sx = Math.sin(pitch);
    const cr = Math.cos(roll), sr = Math.sin(roll);
    const driftX = Math.sin(time * .085 + phase) * 24, driftY = Math.cos(time * .09 + phase) * 15;
    return ([px, py, pz])=>{
        const z = pz * depth;
        const xx = px * cy + z * sy, zz = -px * sy + z * cy;
        const yy = py * cx - zz * sx, z2 = py * sx + zz * cx;
        const perspective = 1500 / (1500 + z2);
        return [
            x + (xx * cr - yy * sr + driftX) * scale * perspective,
            y + (xx * sr + yy * cr + driftY) * scale * perspective
        ];
    };
}
// Geometry is immutable after construction. Compile its topology once, then
// project each shared vertex once per motion group, preserving curve order.
// Weak keys let discarded studies and their compiled geometry be collected.
const $b281c0b7a3469417$var$compiledGeometry = new WeakMap();
function $b281c0b7a3469417$var$compileGeometry(curves) {
    const groups = new Map(), rows = [];
    for (const curve of curves){
        const key = curve.arrival !== undefined ? curve.arrival : curve.travel || 'static';
        if (!groups.has(key)) groups.set(key, {
            curve: curve,
            lookup: new Map(),
            points: [],
            output: [],
            active: false
        });
        const group = groups.get(key);
        const indices = curve.points.map((point)=>{
            const vertex = point.join(',');
            if (!group.lookup.has(vertex)) {
                group.lookup.set(vertex, group.points.length);
                group.points.push(point);
            }
            return group.lookup.get(vertex);
        });
        rows.push({
            group: group,
            indices: indices
        });
    }
    const scene = {
        groups: [
            ...groups.values()
        ],
        rows: rows
    };
    for (const group of scene.groups)delete group.lookup;
    $b281c0b7a3469417$var$compiledGeometry.set(curves, scene);
    return scene;
}
function $b281c0b7a3469417$export$9154120554b8ccbd(curves, project, seconds, settled = false) {
    const scene = $b281c0b7a3469417$var$compiledGeometry.get(curves) || $b281c0b7a3469417$var$compileGeometry(curves);
    for (const group of scene.groups){
        const offset = $b281c0b7a3469417$export$b64aebf1049813c0(group.curve, seconds, settled);
        group.active = !!offset;
        if (!offset) continue;
        for(let i = 0; i < group.points.length; i++){
            const p = group.points[i];
            const [x, y] = project([
                p[0] + offset[0],
                p[1] + offset[1],
                p[2] + offset[2]
            ]);
            group.output[i] = `${x.toFixed(1)},${y.toFixed(1)}`;
        }
    }
    let path = '';
    for (const { group: group, indices: indices } of scene.rows){
        if (!group.active) continue;
        for(let i = 0; i < indices.length; i++)path += (i ? 'L' : 'M') + group.output[indices[i]];
    }
    return path;
}

});

// Freeze both geometry and camera on the inactive side. Each 30-second cycle
// has 12 seconds of training, a pause, 15 seconds of ARC, then another pause.
function $ccb7e79fd3b726ea$export$57a8ab38cad627aa(seconds) {
    const cycle = Math.floor(seconds / 30);
    const phase = seconds % 30;
    const arcProgress = Math.max(0, Math.min(15, phase - 13));
    return {
        training: (cycle * 12 + Math.min(12, phase)) * .55,
        arcCamera: (cycle * 15 + arcProgress) * .42,
        arcArrival: phase < 13 ? 6.3 : arcProgress * .42
    };
}
function $ccb7e79fd3b726ea$export$1f651ab415ac1c90(hero, draw, layout) {
    const abort = new AbortController();
    const options = {
        signal: abort.signal
    };
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 700px)');
    const print = matchMedia('print');
    let visible = true, disposed = false;
    let frame = 0, previous = null, elapsed = 0;
    const render = ()=>draw(elapsed / 1000, mobile.matches, reduced.matches);
    function tick(time) {
        if (disposed) return;
        if (previous !== null) elapsed += Math.min(time - previous, 80);
        previous = time;
        render();
        frame = requestAnimationFrame(tick);
    }
    function playback() {
        cancelAnimationFrame(frame);
        frame = 0;
        previous = null;
        if (!disposed && !reduced.matches && visible && !document.hidden && !print.matches) frame = requestAnimationFrame(tick);
    }
    function resize() {
        layout(mobile.matches);
        render();
    }
    reduced.addEventListener('change', ()=>{
        render();
        playback();
    }, options);
    mobile.addEventListener('change', resize, options);
    print.addEventListener('change', playback, options);
    document.addEventListener('visibilitychange', playback, options);
    const observer = new IntersectionObserver(([entry])=>{
        visible = entry.isIntersecting;
        playback();
    });
    observer.observe(hero);
    resize();
    playback();
    return ()=>{
        disposed = true;
        abort.abort();
        cancelAnimationFrame(frame);
        observer.disconnect();
    };
}



var $4ACxo = parcelRequire("4ACxo");
function $14e3b3396488c86f$export$5698593167017a47(hero, { id: id, caption: caption, scene: scene, titleRows: titleRows, viewBox: viewBox, centerTitle: centerTitle = false }) {
    const bounds = viewBox || ((small)=>small ? '0 0 760 640' : '0 0 1200 440');
    const ns = 'http://www.w3.org/2000/svg';
    const element = (tag, attributes = {}, text = '')=>{
        const node = document.createElementNS(ns, tag);
        for (const [key, value] of Object.entries(attributes))node.setAttribute(key, value);
        if (text) node.textContent = text;
        return node;
    };
    const svg = element('svg', {
        viewBox: bounds(false),
        'aria-hidden': 'true',
        focusable: 'false',
        class: 'research-hero-scene'
    });
    const defs = element('defs');
    const name = element('text', {
        id: `${id}-name`,
        class: 'research-hero-name'
    });
    if (centerTitle) name.setAttribute('text-anchor', 'middle');
    const lines = element('path', {
        id: `${id}-lines`
    });
    const layerPaths = (scene.layers || []).map((layer, i)=>element('path', {
            id: `${id}-layer-${i}`
        }));
    const labels = element('g', {
        id: `${id}-labels`,
        class: 'research-hero-labels'
    });
    const labelNodes = scene.labels.map(()=>element('text', {
            'text-anchor': 'middle'
        }));
    labels.append(...labelNodes);
    const clip = element('clipPath', {
        id: `${id}-mask`
    });
    clip.append(element('use', {
        href: `#${id}-name`
    }));
    defs.append(name, lines, ...layerPaths, labels, clip);
    svg.append(defs);
    const layerUse = (layer, i, className)=>{
        const group = element('g', {
            opacity: layer.opacity
        });
        const use = element('use', {
            href: `#${id}-layer-${i}`,
            class: className
        });
        if (layer.strokeWidth) use.style.strokeWidth = layer.strokeWidth;
        group.append(use);
        return group;
    };
    (scene.layers || []).forEach((layer, i)=>svg.append(layerUse(layer, i, 'research-hero-wires')));
    svg.append(element('use', {
        href: `#${id}-lines`,
        class: 'research-hero-wires'
    }));
    svg.append(element('use', {
        href: `#${id}-labels`,
        class: 'research-hero-label-ink'
    }));
    svg.append(element('use', {
        href: `#${id}-name`,
        class: 'research-hero-type'
    }));
    const overlap = element('g', {
        'clip-path': `url(#${id}-mask)`
    });
    (scene.layers || []).forEach((layer, i)=>{
        if (layer.overlap !== false) overlap.append(layerUse(layer, i, 'research-hero-overlap'));
    });
    overlap.append(element('use', {
        href: `#${id}-lines`,
        class: 'research-hero-overlap'
    }));
    overlap.append(element('use', {
        href: `#${id}-labels`,
        class: 'research-hero-label-teal'
    }));
    svg.append(overlap);
    const [fallback, ...otherFallbacks] = hero.querySelectorAll('.research-hero-scene');
    if (fallback) fallback.replaceWith(svg);
    else hero.append(svg);
    otherFallbacks.forEach((node)=>node.remove());
    // The static shell reserves the final scene and controls before JS loads.
    // Enhance it in place so the content below never has to move down.
    const controls = hero.querySelector('.research-hero-controls') || document.createElement('div');
    controls.className = 'research-hero-controls';
    const description = controls.querySelector('span') || document.createElement('span');
    description.textContent = caption;
    controls.append(description);
    hero.append(controls);
    hero.classList.add('research-hero');
    let previousPath;
    const previousLayers = [];
    function fitTitle() {
        if (!centerTitle) return;
        const [x, y, width, height] = svg.getAttribute('viewBox').split(' ').map(Number);
        const rect = svg.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const scale = (0, $4ACxo.mastheadTitleScale)(hero, Math.min(rect.width / width, rect.height / height), width);
        name.setAttribute('transform', (0, $4ACxo.centeredTitleTransform)(scale, x + width / 2, y + height / 2));
    }
    const titleObserver = centerTitle ? new ResizeObserver(fitTitle) : null;
    titleObserver?.observe(svg);
    const stopMotion = (0, $ccb7e79fd3b726ea$export$1f651ab415ac1c90)(hero, (seconds, small, reduced)=>{
        const rendered = scene.draw(seconds, small, reduced);
        if (rendered.path !== previousPath) {
            lines.setAttribute('d', rendered.path);
            previousPath = rendered.path;
        }
        layerPaths.forEach((path, i)=>{
            const value = rendered.layers?.[i] || '';
            if (value !== previousLayers[i]) {
                path.setAttribute('d', value);
                previousLayers[i] = value;
            }
        });
        rendered.labels.forEach((label, i)=>{
            labelNodes[i].setAttribute('x', label.x);
            labelNodes[i].setAttribute('y', label.y);
            labelNodes[i].textContent = label.text;
        });
    }, (small)=>{
        svg.setAttribute('viewBox', bounds(small));
        name.replaceChildren();
        const rows = titleRows ? titleRows(small) : small ? [
            [
                45,
                265,
                'M L'
            ],
            [
                45,
                440,
                'Newton'
            ]
        ] : [
            [
                50,
                285,
                'M L Newton'
            ]
        ];
        rows.forEach(([x, y, text])=>name.append(element('tspan', {
                x: x,
                y: y
            }, text)));
        fitTitle();
    });
    return ()=>{
        titleObserver?.disconnect();
        stopMotion();
    };
}


var $556ff8d20f3a1e41$exports = {};

$parcel$export($556ff8d20f3a1e41$exports, "createDitChapterScene", () => $556ff8d20f3a1e41$export$b1c2be38fe671aa4);
$parcel$export($556ff8d20f3a1e41$exports, "createOtherResearchChapterScene", () => $556ff8d20f3a1e41$export$22fdd080ef1c0640);
$parcel$export($556ff8d20f3a1e41$exports, "createEditingChapterScene", () => $43853c709e3b11ec$export$934973c2a4c5a085);
$parcel$export($556ff8d20f3a1e41$exports, "createDancingChapterScene", () => $21e6e912c8ab293f$export$c9da12a1b5d83c67);
$parcel$export($556ff8d20f3a1e41$exports, "createWorkflowChapterScene", () => $21e6e912c8ab293f$export$2aa24c9f3fc96dd6);

var $fkbDJ = parcelRequire("fkbDJ");
const $4d27c3991cee4fe1$export$24c8f955ba88a6b3 = [
    {
        id: '05269061',
        input: [
            '0000000',
            '0000000',
            '0000001',
            '0000012',
            '0000124',
            '0001240',
            '0012400'
        ],
        output: [
            '2412412',
            '4124124',
            '1241241',
            '2412412',
            '4124124',
            '1241241',
            '2412412'
        ]
    },
    {
        id: '00d62c1b',
        input: [
            '0000000000',
            '0033330000',
            '0030030000',
            '0030030300',
            '0033333330',
            '0003000030',
            '0003000330',
            '0003300303',
            '0003030030',
            '0000300000'
        ],
        output: [
            '0000000000',
            '0033330000',
            '0034430000',
            '0034430300',
            '0033333330',
            '0003000030',
            '0003000330',
            '0003300343',
            '0003430030',
            '0000300000'
        ]
    }
];
const $4d27c3991cee4fe1$var$clamp = (t)=>Math.max(0, Math.min(1, t));
const $4d27c3991cee4fe1$var$ease = (t)=>{
    t = $4d27c3991cee4fe1$var$clamp(t);
    return t * t * (3 - 2 * t);
};
const $4d27c3991cee4fe1$var$line = (points)=>({
        points: points
    });
const $4d27c3991cee4fe1$var$rect = (x, y, w, h, z = 0)=>$4d27c3991cee4fe1$var$line([
        [
            x,
            y,
            z
        ],
        [
            x + w,
            y,
            z
        ],
        [
            x + w,
            y + h,
            z
        ],
        [
            x,
            y + h,
            z
        ],
        [
            x,
            y,
            z
        ]
    ]);
const $4d27c3991cee4fe1$var$glyph = (value)=>{
    if (value === '1') return [
        $4d27c3991cee4fe1$var$line([
            [
                -0.3,
                .3,
                0
            ],
            [
                .3,
                -0.3,
                0
            ]
        ])
    ];
    if (value === '2') return [
        $4d27c3991cee4fe1$var$line([
            [
                -0.3,
                -0.3,
                0
            ],
            [
                .3,
                .3,
                0
            ]
        ])
    ];
    if (value === '3') return [
        $4d27c3991cee4fe1$var$rect(-0.3, -0.3, .6, .6)
    ];
    if (value === '4') return [
        $4d27c3991cee4fe1$var$line([
            [
                -0.3,
                -0.3,
                0
            ],
            [
                .3,
                .3,
                0
            ]
        ]),
        $4d27c3991cee4fe1$var$line([
            [
                -0.3,
                .3,
                0
            ],
            [
                .3,
                -0.3,
                0
            ]
        ])
    ];
    if (value === '?') return [
        $4d27c3991cee4fe1$var$rect(-0.06, -0.06, .12, .12)
    ];
    return [];
};
const $4d27c3991cee4fe1$var$move = (curves, x, y, size, z = 0)=>curves.map(({ points: points })=>$4d27c3991cee4fe1$var$line(points.map((p)=>[
                x + p[0] * size,
                y + p[1] * size,
                z + p[2]
            ])));
const $4d27c3991cee4fe1$var$cell = (value)=>[
        $4d27c3991cee4fe1$var$rect(-0.46, -0.46, .92, .92),
        ...$4d27c3991cee4fe1$var$glyph(value)
    ];
const $4d27c3991cee4fe1$var$separator = [
    $4d27c3991cee4fe1$var$line([
        [
            -0.25,
            -0.25,
            0
        ],
        [
            .25,
            -0.25,
            0
        ],
        [
            .25,
            .25,
            0
        ],
        [
            -0.25,
            .25,
            0
        ]
    ]),
    $4d27c3991cee4fe1$var$line([
        [
            -0.25,
            .25,
            0
        ],
        [
            -0.07,
            .08,
            0
        ]
    ])
];
function $4d27c3991cee4fe1$export$c93bd32f750b4e77(example) {
    // Rank the serialized output, including one row separator per row. Copied
    // cells and structural tokens resolve before harder pattern completion.
    // The ordering is illustrative; every batch draws from this same token pool.
    const n = example.input.length, tokens = [];
    for(let r = 0; r < n; r++)for(let c = 0; c <= n; c++){
        const index = r * (n + 1) + c;
        const easy = c === n || example.input[r][c] === example.output[r][c];
        tokens.push({
            index: index,
            priority: (easy ? 0 : 1000) + index * 37 % 101
        });
    }
    return tokens.sort((a, b)=>a.priority - b.priority).map(({ index: index })=>index);
}
function $4d27c3991cee4fe1$export$63fb9b6dfe405f9(seconds, reduced = false) {
    const cycle = Math.floor(Math.max(0, seconds) / 16), phase = reduced ? 14 : Math.max(0, seconds) % 16;
    const example = reduced ? 0 : cycle % $4d27c3991cee4fe1$export$24c8f955ba88a6b3.length, n = $4d27c3991cee4fe1$export$24c8f955ba88a6b3[example].input.length;
    // n equal batches of n+1 tokens exactly exhaust cells plus separators.
    const batchSize = n + 1, batchDuration = 10 / n;
    const batch = Math.min(n, Math.max(0, Math.floor((phase - 1) / batchDuration) + 1));
    return {
        example: example,
        phase: phase,
        batchSize: batchSize,
        batchDuration: batchDuration,
        batch: batch,
        revealed: batch * batchSize,
        structure: $4d27c3991cee4fe1$var$ease(batch / n),
        solved: batch / n
    };
}
function $4d27c3991cee4fe1$export$6c1f04e963e2ed91(rank, n) {
    return 1 + Math.floor(rank / (n + 1)) * (10 / n);
}
function $4d27c3991cee4fe1$export$47015266a181122d(age, reduced = false) {
    if (reduced || age < 0 || age >= 1.5) return 0;
    return -110 * Math.exp(-3.6 * age) * Math.cos(9 * age) * (1 - $4d27c3991cee4fe1$var$ease((age - 1) / .5));
}
function $4d27c3991cee4fe1$var$model(example) {
    const n = example.input.length, step = 180 / n, curves = [], ranks = [];
    $4d27c3991cee4fe1$export$c93bd32f750b4e77(example).forEach((index, rank)=>ranks[index] = rank);
    for(let r = 0; r < n; r++)for(let c = 0; c < n; c++)curves.push(...$4d27c3991cee4fe1$var$move($4d27c3991cee4fe1$var$cell(example.input[r][c]), -220 + (c + .5) * step, -95 + (r + .5) * step, step));
    // Keep the complete serialized input beneath the two panels, including its
    // row separators. This strip is never masked or removed during a solve.
    const tokenStep = 440 / (n * (n + 1));
    for(let r = 0; r < n; r++)for(let c = 0; c <= n; c++){
        const x = -220 + (r * (n + 1) + c + .5) * tokenStep;
        curves.push(...$4d27c3991cee4fe1$var$move(c === n ? $4d27c3991cee4fe1$var$separator : $4d27c3991cee4fe1$var$cell(example.input[r][c]), x, 119, tokenStep * .9));
    }
    curves.push($4d27c3991cee4fe1$var$line([
        [
            -220,
            108,
            0
        ],
        [
            -220,
            100,
            0
        ],
        [
            -40,
            100,
            0
        ]
    ]));
    curves.push($4d27c3991cee4fe1$var$line([
        [
            -20,
            -5,
            0
        ],
        [
            10,
            -5,
            0
        ],
        [
            2,
            -11,
            0
        ]
    ]), $4d27c3991cee4fe1$var$line([
        [
            10,
            -5,
            0
        ],
        [
            2,
            1,
            0
        ]
    ]));
    const cells = example.output.join('').split('').map((value)=>({
            masked: $4d27c3991cee4fe1$var$cell('?'),
            solved: $4d27c3991cee4fe1$var$cell(value)
        }));
    return {
        n: n,
        step: step,
        curves: curves,
        ranks: ranks,
        cells: cells
    };
}
function $4d27c3991cee4fe1$export$f2438fc71952b444(variant = 'fold') {
    const models = $4d27c3991cee4fe1$export$24c8f955ba88a6b3.map($4d27c3991cee4fe1$var$model);
    let lastKey, last;
    return {
        labels: [],
        draw (seconds, small, reduced = false) {
            const t = reduced ? 0 : Math.floor(seconds * (small ? 24 : 30)) / (small ? 24 : 30);
            const key = `${t}/${small}/${reduced}`;
            if (key === lastKey) return last;
            const state = $4d27c3991cee4fe1$export$63fb9b6dfe405f9(t, reduced), m = models[state.example];
            const project = (0, $fkbDJ.projector)({
                time: t * .12,
                phase: 2.5,
                x: small ? 380 : 315,
                y: small ? 188 : 237,
                scale: small ? 1.12 : 1.05,
                depth: .7
            });
            let path = (0, $fkbDJ.renderCurves)(m.curves, project, 0, true);
            for(let r = 0; r < m.n; r++){
                const separatorToken = r * (m.n + 1) + m.n;
                const separatorReady = m.ranks[separatorToken] < state.revealed;
                const separatorAge = state.phase - $4d27c3991cee4fe1$export$6c1f04e963e2ed91(m.ranks[separatorToken], m.n);
                const rowProgress = reduced || variant === 'grid' ? 1 : variant === 'ribbon' ? state.structure : separatorReady ? $4d27c3991cee4fe1$var$ease(separatorAge / .65) : 0;
                for(let c = 0; c < m.n; c++){
                    const index = r * m.n + c, token = r * (m.n + 1) + c;
                    const sx = 30 + token % 28 * 6.7, sy = -120 + Math.floor(token / 28) * 12;
                    const tx = 30 + (c + .5) * m.step, ty = -95 + (r + .5) * m.step;
                    const x = sx + (tx - sx) * rowProgress, y = sy + (ty - sy) * rowProgress;
                    const size = 6 + (m.step - 6) * rowProgress;
                    const ready = m.ranks[token] < state.revealed;
                    const age = state.phase - $4d27c3991cee4fe1$export$6c1f04e963e2ed91(m.ranks[token], m.n);
                    const z = Math.sin(rowProgress * Math.PI) * (variant === 'ribbon' ? 85 : 55) + (ready ? $4d27c3991cee4fe1$export$47015266a181122d(age, reduced) : 0);
                    if (ready && Math.abs(z) > 2) // Short corner stalks make the front/back displacement read
                    // as depth rather than a sideways move in the flat grid.
                    for (const [cx, cy] of [
                        [
                            -0.46,
                            -0.46
                        ],
                        [
                            .46,
                            .46
                        ]
                    ]){
                        const a = project([
                            x + cx * size,
                            y + cy * size,
                            0
                        ]), b = project([
                            x + cx * size,
                            y + cy * size,
                            z
                        ]);
                        path += `M${a[0].toFixed(1)},${a[1].toFixed(1)}L${b[0].toFixed(1)},${b[1].toFixed(1)}`;
                    }
                    path += (0, $fkbDJ.renderCurves)(ready ? m.cells[index].solved : m.cells[index].masked, (p)=>project([
                            x + p[0] * size,
                            y + p[1] * size,
                            z
                        ]), 0, true);
                }
                // The separator occupies a masked slot and consumes one reveal in
                // its batch, just like a cell. Its reveal triggers this row's fold.
                const sx = 30 + separatorToken % 28 * 6.7, sy = -120 + Math.floor(separatorToken / 28) * 12;
                const x = sx + (218 - sx) * rowProgress, y = sy + (-95 + (r + .5) * m.step - sy) * rowProgress;
                const size = 6 + 2 * rowProgress;
                const z = separatorReady ? $4d27c3991cee4fe1$export$47015266a181122d(separatorAge, reduced) : 0;
                path += (0, $fkbDJ.renderCurves)(separatorReady ? $4d27c3991cee4fe1$var$separator : $4d27c3991cee4fe1$var$cell('?'), (p)=>project([
                        x + p[0] * size,
                        y + p[1] * size,
                        z
                    ]), 0, true);
            }
            lastKey = key;
            last = {
                path: path,
                labels: []
            };
            return last;
        }
    };
}



var $fkbDJ = parcelRequire("fkbDJ");
// Schematic single-stream DiT, informed by Krea 2's public report:
// https://www.krea.ai/blog/krea-2-technical-report
// Repeated planes are illustrative, not a model-specific layer count.

var $fkbDJ = parcelRequire("fkbDJ");
const $8f62aaa2d023eb86$var$line = (points, extra = {})=>({
        points: points,
        ...extra
    });
const $8f62aaa2d023eb86$var$rect = (x, y, w, h, z)=>[
        [
            x,
            y,
            z
        ],
        [
            x + w,
            y,
            z
        ],
        [
            x + w,
            y + h,
            z
        ],
        [
            x,
            y + h,
            z
        ],
        [
            x,
            y,
            z
        ]
    ];
function $8f62aaa2d023eb86$var$box(x, y, w, h, z, depth, extra = {}) {
    const front = $8f62aaa2d023eb86$var$rect(x, y, w, h, z), back = $8f62aaa2d023eb86$var$rect(x, y, w, h, z + depth);
    return [
        $8f62aaa2d023eb86$var$line(front, extra),
        $8f62aaa2d023eb86$var$line(back, extra),
        ...front.slice(0, 4).map((p, i)=>$8f62aaa2d023eb86$var$line([
                p,
                back[i]
            ], extra))
    ];
}
function $8f62aaa2d023eb86$export$71e7376babd52330(small = false) {
    const curves = [], labels = [];
    const label = (text, x, y, z = 0)=>labels.push({
            text: text,
            point: [
                x,
                y,
                z
            ]
        });
    const grid = (x, y, w, h, cols, rows)=>{
        curves.push(...$8f62aaa2d023eb86$var$box(x, y, w, h, 0, 15));
        for(let c = 1; c < cols; c++)curves.push($8f62aaa2d023eb86$var$line([
            [
                x + w * c / cols,
                y,
                0
            ],
            [
                x + w * c / cols,
                y + h,
                0
            ]
        ]));
        for(let r = 1; r < rows; r++)curves.push($8f62aaa2d023eb86$var$line([
            [
                x,
                y + h * r / rows,
                0
            ],
            [
                x + w,
                y + h * r / rows,
                0
            ]
        ]));
    };
    const route = (points, offset = 0)=>{
        curves.push($8f62aaa2d023eb86$var$line(points));
        const end = points.at(-1), before = points.at(-2);
        const dx = end[0] - before[0], dy = end[1] - before[1], length = Math.hypot(dx, dy), ux = dx / length, uy = dy / length;
        curves.push($8f62aaa2d023eb86$var$line([
            [
                end[0] - ux * 9 + uy * 4,
                end[1] - uy * 9 - ux * 4,
                end[2]
            ],
            end,
            [
                end[0] - ux * 9 - uy * 4,
                end[1] - uy * 9 + ux * 4,
                end[2]
            ]
        ]));
        for(let packet = 0; packet < 3; packet++)curves.push(...$8f62aaa2d023eb86$var$box(-6, -6, 12, 12, 0, 8, {
            travel: {
                route: points,
                period: 12,
                offset: offset + packet * 4
            }
        }));
    };
    if (small) {
        grid(-250, -245, 155, 65, 6, 2);
        grid(90, -255, 125, 95, 5, 4);
        label('TEXT', -172, -275);
        label('IMAGE', 152, -285);
        grid(-140, -75, 280, 45, 14, 1);
        route([
            [
                -172,
                -180,
                0
            ],
            [
                -172,
                -125,
                0
            ],
            [
                -70,
                -125,
                0
            ],
            [
                -70,
                -75,
                0
            ]
        ]);
        route([
            [
                152,
                -160,
                0
            ],
            [
                152,
                -125,
                0
            ],
            [
                70,
                -125,
                0
            ],
            [
                70,
                -75,
                0
            ]
        ]);
        route([
            [
                0,
                -30,
                0
            ],
            [
                0,
                48,
                80
            ]
        ], 3);
        grid(-285, 95, 75, 35, 3, 1);
        route([
            [
                -210,
                112,
                0
            ],
            [
                -115,
                112,
                80
            ]
        ], 3);
        grid(-70, 330, 140, 80, 7, 4);
        route([
            [
                0,
                232,
                80
            ],
            [
                0,
                330,
                0
            ]
        ], 7);
    } else {
        grid(-505, -125, 150, 65, 6, 2);
        grid(-495, 70, 135, 110, 5, 4);
        label('TEXT', -430, -145);
        label('IMAGE', -428, 200);
        grid(-260, -82, 64, 164, 2, 8);
        route([
            [
                -355,
                -92,
                0
            ],
            [
                -300,
                -92,
                0
            ],
            [
                -300,
                -40,
                0
            ],
            [
                -260,
                -40,
                0
            ]
        ]);
        route([
            [
                -360,
                125,
                0
            ],
            [
                -300,
                125,
                0
            ],
            [
                -300,
                40,
                0
            ],
            [
                -260,
                40,
                0
            ]
        ]);
        route([
            [
                -196,
                0,
                0
            ],
            [
                -105,
                0,
                80
            ]
        ], 3);
        grid(-35, -205, 120, 30, 5, 1);
        route([
            [
                25,
                -175,
                0
            ],
            [
                25,
                -112,
                80
            ]
        ], 3);
        grid(325, -60, 125, 120, 5, 5);
        route([
            [
                125,
                0,
                80
            ],
            [
                325,
                0,
                0
            ]
        ], 7);
    }
    const x = small ? -115 : -105, y = small ? 48 : -112, w = 230, h = small ? 184 : 224;
    for (const z of [
        0,
        32,
        64
    ])curves.push(...$8f62aaa2d023eb86$var$box(x, y, w, h, z, 16));
    // Two fields of square tokens replace the text-heavy sublayer boxes.
    // A staggered wave carries selected squares through the stacked planes.
    for(let band = 0; band < 2; band++){
        const top = band === 0 ? y + 22 : y + h - 77;
        for(let row = 0; row < 2; row++)for(let col = 0; col < 6; col++){
            const left = x + 18 + col * 29, yy = top + row * 29;
            curves.push($8f62aaa2d023eb86$var$line($8f62aaa2d023eb86$var$rect(left, yy, 22, 22, 80)));
            if ((col + row + band) % 2 === 0) {
                const route = [
                    [
                        left,
                        yy,
                        0
                    ],
                    [
                        left,
                        yy,
                        80
                    ],
                    [
                        left,
                        yy,
                        0
                    ]
                ];
                curves.push(...$8f62aaa2d023eb86$var$box(0, 0, 22, 22, 0, 5, {
                    travel: {
                        route: route,
                        period: 10,
                        offset: col * .8 + row * 1.3 + band * 2
                    }
                }));
            }
        }
    }
    label('DiT', x + w / 2, y + h + 36);
    // Residual path around the attention and MLP sublayers.
    curves.push($8f62aaa2d023eb86$var$line([
        [
            x + w - 27,
            y + 10,
            80
        ],
        [
            x + w - 10,
            y + 10,
            80
        ],
        [
            x + w - 10,
            y + h - 10,
            80
        ],
        [
            x + w - 27,
            y + h - 10,
            80
        ]
    ]));
    return {
        curves: curves,
        labels: labels
    };
}
function $8f62aaa2d023eb86$export$a4064969641f660d() {
    const desktop = $8f62aaa2d023eb86$export$71e7376babd52330(), mobile = $8f62aaa2d023eb86$export$71e7376babd52330(true);
    return {
        labels: desktop.labels,
        draw (seconds, small) {
            const geometry = small ? mobile : desktop, time = seconds * .35;
            const project = (0, $fkbDJ.projector)({
                time: time,
                phase: .8,
                x: small ? 380 : 610,
                y: small ? 270 : 228,
                scale: small ? .69 : .82,
                depth: .85
            });
            return {
                path: (0, $fkbDJ.renderCurves)(geometry.curves, project, seconds * .7),
                labels: geometry.labels.map((label)=>{
                    const [x, y] = project(label.point);
                    return {
                        text: label.text,
                        x: x,
                        y: y
                    };
                })
            };
        }
    };
}


// Decorative SecAggIBLT schematic, based on Google's public explanation:
// https://research.google/blog/improving-gboard-language-models-via-private-federated-analytics/
// Local sketches combine into an aggregate table; decoding recovers entries.
// Cell counts, hash collisions and cryptography are not simulated here.
const $1021d77fd48e7306$var$line = (points, extra = {})=>({
        points: points,
        ...extra
    });
const $1021d77fd48e7306$var$rect = (x, y, w, h, z)=>[
        [
            x,
            y,
            z
        ],
        [
            x + w,
            y,
            z
        ],
        [
            x + w,
            y + h,
            z
        ],
        [
            x,
            y + h,
            z
        ],
        [
            x,
            y,
            z
        ]
    ];
function $1021d77fd48e7306$var$box(x, y, w, h, z, depth, extra = {}) {
    const front = $1021d77fd48e7306$var$rect(x, y, w, h, z), back = $1021d77fd48e7306$var$rect(x, y, w, h, z + depth);
    return [
        $1021d77fd48e7306$var$line(front, extra),
        $1021d77fd48e7306$var$line(back, extra),
        ...front.slice(0, 4).map((p, i)=>$1021d77fd48e7306$var$line([
                p,
                back[i]
            ], extra))
    ];
}
function $1021d77fd48e7306$export$e3c49a7401c4be20() {
    const curves = [];
    const table = (x, y, cols, rows, cell, z, depth)=>{
        curves.push(...$1021d77fd48e7306$var$box(x, y, cols * cell, rows * cell, z, depth));
        for(let c = 1; c < cols; c++)curves.push($1021d77fd48e7306$var$line([
            [
                x + c * cell,
                y,
                z
            ],
            [
                x + c * cell,
                y + rows * cell,
                z
            ]
        ]));
        for(let r = 1; r < rows; r++)curves.push($1021d77fd48e7306$var$line([
            [
                x,
                y + r * cell,
                z
            ],
            [
                x + cols * cell,
                y + r * cell,
                z
            ]
        ]));
    };
    // Separate local sketches meet at an aggregation junction. Only the
    // resulting aggregate has a path into the decoder/output side.
    for(let device = 0; device < 3; device++){
        const y = -174 + device * 135;
        curves.push(...$1021d77fd48e7306$var$box(-432, y - 12, 58, 92, 0, 12));
        curves.push($1021d77fd48e7306$var$line($1021d77fd48e7306$var$rect(-424, y, 42, 54, 0)), $1021d77fd48e7306$var$line([
            [
                -413,
                y + 67,
                0
            ],
            [
                -395,
                y + 67,
                0
            ]
        ]));
        table(-332, y, 3, 3, 22, 12, 12);
        curves.push($1021d77fd48e7306$var$line([
            [
                -374,
                y + 30,
                0
            ],
            [
                -332,
                y + 30,
                12
            ]
        ]));
        const route = [
            [
                -266,
                y + 33,
                12
            ],
            [
                -206,
                y + 33,
                12
            ],
            [
                -155,
                0,
                30
            ]
        ];
        curves.push($1021d77fd48e7306$var$line(route));
        for(let packet = 0; packet < 2; packet++)curves.push(...$1021d77fd48e7306$var$box(-6, -6, 12, 12, 0, 7, {
            travel: {
                route: route,
                period: 10,
                offset: device * 1.6 + packet * 5
            }
        }));
        // Three distinct occupied buckets hint at multi-hash insertion.
        for(let col = 0; col < 3; col++){
            const row = (col + device) % 3;
            curves.push($1021d77fd48e7306$var$line($1021d77fd48e7306$var$rect(-329 + col * 22, y + 3 + row * 22, 16, 16, 12)));
        }
    }
    curves.push(...$1021d77fd48e7306$var$box(-165, -10, 20, 20, 20, 20));
    const combined = [
        [
            -145,
            0,
            30
        ],
        [
            -90,
            0,
            30
        ]
    ];
    curves.push($1021d77fd48e7306$var$line(combined), ...$1021d77fd48e7306$var$box(-8, -8, 16, 16, 0, 10, {
        travel: {
            route: combined,
            period: 6,
            offset: 1
        }
    }));
    // A stack of aligned 3 x 8 tables suggests linear aggregation.
    for (const z of [
        0,
        18,
        36
    ])table(-90, -144, 3, 8, 36, z, 6);
    for(let row = 0; row < 8; row++){
        const col = (row * 2 + 1) % 3, x = -84 + col * 36, y = -138 + row * 36;
        curves.push($1021d77fd48e7306$var$line($1021d77fd48e7306$var$rect(x, y, 24, 24, 42)));
        if (row % 2 === 0) {
            const outY = -126 + row * 36;
            const route = [
                [
                    x + 12,
                    y + 12,
                    42
                ],
                [
                    94,
                    y + 12,
                    42
                ],
                [
                    176,
                    outY,
                    16
                ],
                [
                    306,
                    outY,
                    16
                ]
            ];
            curves.push($1021d77fd48e7306$var$line(route), ...$1021d77fd48e7306$var$box(-8, -8, 16, 16, 0, 8, {
                travel: {
                    route: route,
                    period: 12,
                    offset: row * 1.2
                }
            }));
            curves.push(...$1021d77fd48e7306$var$box(306, outY - 19, 92, 38, 0, 16));
            for(let token = 0; token < 3; token++)curves.push($1021d77fd48e7306$var$line($1021d77fd48e7306$var$rect(315 + token * 26, outY - 10, 18, 20, 16)));
        }
    }
    return {
        curves: curves,
        labels: [
            {
                text: 'SKETCHES',
                point: [
                    -300,
                    218,
                    12
                ]
            },
            {
                text: 'SecAgg',
                point: [
                    -155,
                    70,
                    30
                ]
            },
            {
                text: 'IBLT',
                point: [
                    -36,
                    184,
                    36
                ]
            },
            {
                text: 'DECODE',
                point: [
                    350,
                    184,
                    16
                ]
            }
        ]
    };
}




var $fkbDJ = parcelRequire("fkbDJ");
// A schematic of image retrieval and pair curation, not real embedding coordinates.
const $43853c709e3b11ec$var$line = (points)=>({
        points: points
    });
const $43853c709e3b11ec$var$rect = (x, y, w, h, z = 0)=>[
        [
            x,
            y,
            z
        ],
        [
            x + w,
            y,
            z
        ],
        [
            x + w,
            y + h,
            z
        ],
        [
            x,
            y + h,
            z
        ],
        [
            x,
            y,
            z
        ]
    ];
const $43853c709e3b11ec$var$clamp = (value)=>Math.max(0, Math.min(1, value));
const $43853c709e3b11ec$var$ease = (value)=>{
    const t = $43853c709e3b11ec$var$clamp(value);
    return t * t * (3 - 2 * t);
};
const $43853c709e3b11ec$var$mix = (a, b, t)=>a.map((v, i)=>v + (b[i] - v) * t);
const $43853c709e3b11ec$var$shift = (curves, at, scale = 1)=>curves.map(({ points: points })=>$43853c709e3b11ec$var$line(points.map((p)=>p.map((v, i)=>at[i] + v * scale))));
function $43853c709e3b11ec$var$imageCard(variant = 0) {
    const curves = [
        $43853c709e3b11ec$var$line($43853c709e3b11ec$var$rect(-28, -22, 56, 44)),
        $43853c709e3b11ec$var$line([
            [
                -24,
                15,
                0
            ],
            [
                -7,
                -5,
                0
            ],
            [
                3,
                7,
                0
            ],
            [
                12,
                -2,
                0
            ],
            [
                24,
                15,
                0
            ]
        ])
    ];
    const circle = [];
    for(let i = 0; i <= 16; i++){
        const angle = i * Math.PI / 8;
        circle.push([
            13 + Math.cos(angle) * 5,
            -11 + Math.sin(angle) * 5,
            0
        ]);
    }
    curves.push($43853c709e3b11ec$var$line(circle));
    if (variant) curves.push($43853c709e3b11ec$var$line([
        [
            -22,
            -10,
            0
        ],
        [
            -14,
            -10,
            0
        ],
        [
            -10,
            -14,
            0
        ],
        [
            -4,
            -10,
            0
        ]
    ]));
    return curves;
}
function $43853c709e3b11ec$export$3d043a211b8a02eb(seconds, reduced = false) {
    const phase = reduced ? 12 : (seconds % 22 + 22) % 22;
    return {
        phase: phase,
        gather: $43853c709e3b11ec$var$ease((phase - 4) / 4),
        review: $43853c709e3b11ec$var$clamp((phase - 8) / 4),
        deliver: $43853c709e3b11ec$var$ease((phase - 13) / 5),
        presence: reduced ? 1 : $43853c709e3b11ec$var$ease((phase - 2.5) / 1) * (1 - $43853c709e3b11ec$var$ease((phase - 21) / 1))
    };
}
function $43853c709e3b11ec$export$18f83102c9b9cfd(review) {
    return [
        [
            60,
            0,
            .1,
            .55,
            18
        ],
        [
            23,
            10,
            .55,
            .95,
            13
        ]
    ].flatMap(([right, y, start, end, tokens])=>{
        const revealed = Math.floor($43853c709e3b11ec$var$clamp((review - start) / (end - start)) * tokens) / tokens;
        return revealed > 0 ? [
            $43853c709e3b11ec$var$line([
                [
                    -65,
                    y,
                    0
                ],
                [
                    -65 + (right + 65) * revealed,
                    y,
                    0
                ]
            ])
        ] : [];
    });
}
function $43853c709e3b11ec$export$2b4017880c7dba72(point, center, seconds, reduced = false) {
    const angle = reduced ? .3 : seconds * .055 + .3;
    const yaw = Math.cos(angle), turn = Math.sin(angle);
    const pitch = .18 * Math.sin(angle * .7);
    const x = point[0] - center[0], y = point[1] - center[1], z = point[2] - center[2];
    const xx = x * yaw + z * turn, zz = -x * turn + z * yaw;
    return [
        center[0] + xx,
        center[1] + y * Math.cos(pitch) - zz * Math.sin(pitch),
        center[2] + y * Math.sin(pitch) + zz * Math.cos(pitch)
    ];
}
function $43853c709e3b11ec$export$57c2b080aa288d8c(point, center, target, destination, seconds, reduced = false) {
    const state = $43853c709e3b11ec$export$3d043a211b8a02eb(seconds, reduced);
    const departureTime = reduced ? 0 : seconds - Math.max(0, state.phase - 4);
    const start = $43853c709e3b11ec$export$2b4017880c7dba72(point, center, departureTime, reduced);
    return $43853c709e3b11ec$var$mix($43853c709e3b11ec$var$mix(start, target, state.gather), destination, state.deliver);
}
function $43853c709e3b11ec$var$geometry(small) {
    const cloud = small ? [
        -55,
        -150,
        210
    ] : [
        -420,
        0,
        240
    ];
    const review = small ? [
        -135,
        145,
        -125
    ] : [
        50,
        0,
        -150
    ];
    const output = small ? [
        170,
        145,
        15
    ] : [
        320,
        0,
        15
    ];
    const cards = [
        $43853c709e3b11ec$var$imageCard(),
        $43853c709e3b11ec$var$imageCard(1)
    ];
    const curves = [], positions = [], cloudCards = [];
    // Many individual image embeddings, spread through a 3D volume. Coordinates
    // are illustrative; nearest-neighbor selection uses their actual distances.
    for(let i = 0; i < 96; i++){
        const angle = i * 2.39996, radius = (small ? 28 : 38) + Math.sqrt(i / 95) * (small ? 204 : 218);
        const at = [
            cloud[0] + Math.cos(angle) * radius,
            cloud[1] + Math.sin(angle) * radius * (small ? .66 : .82),
            cloud[2] + Math.sin(i * 1.7) * (small ? 115 : 150)
        ];
        positions.push(at);
        cloudCards.push({
            card: cards[i % 2],
            at: at,
            size: .32 + (Math.sin(i * 2.1) + 1) * .09
        });
    }
    const anchors = [
        [
            -55,
            -30,
            18
        ],
        [
            52,
            24,
            -20
        ],
        [
            -42,
            42,
            25
        ],
        [
            33,
            -40,
            -24
        ]
    ].map((p)=>p.map((value, i)=>value + cloud[i]));
    const selections = anchors.map((anchor)=>positions.map((at, index)=>({
                at: at,
                index: index,
                distance: Math.hypot(...at.map((v, i)=>v - anchor[i]))
            })).sort((a, b)=>a.distance - b.distance).slice(0, 2));
    // Paired-image review tray and a caption band, then a stack of training pairs.
    curves.push(...$43853c709e3b11ec$var$shift([
        $43853c709e3b11ec$var$line($43853c709e3b11ec$var$rect(-125, -83, 250, 178)),
        $43853c709e3b11ec$var$line([
            [
                -110,
                48,
                0
            ],
            [
                110,
                48,
                0
            ]
        ])
    ], review));
    for(let layer = 2; layer >= 0; layer--){
        const at = [
            output[0] + layer * 7,
            output[1] - layer * 9,
            output[2] + layer * 16
        ];
        curves.push(...$43853c709e3b11ec$var$shift([
            $43853c709e3b11ec$var$line($43853c709e3b11ec$var$rect(-96, -65, 192, 146)),
            $43853c709e3b11ec$var$line([
                [
                    0,
                    -53,
                    0
                ],
                [
                    0,
                    38,
                    0
                ]
            ]),
            $43853c709e3b11ec$var$line([
                [
                    -80,
                    60,
                    0
                ],
                [
                    66,
                    60,
                    0
                ]
            ])
        ], at));
        for(let i = 0; i < 2; i++)curves.push(...$43853c709e3b11ec$var$shift(cards[i], [
            at[0] + (i ? 48 : -48),
            at[1] - 8,
            at[2]
        ], 1.05));
    }
    const route = [
        [
            cloud[0] + (small ? 0 : 174),
            cloud[1] + (small ? 125 : 0),
            cloud[2]
        ],
        [
            review[0] - (small ? 0 : 139),
            review[1] - (small ? 100 : 0),
            review[2]
        ]
    ];
    curves.push($43853c709e3b11ec$var$line(route), $43853c709e3b11ec$var$line([
        [
            review[0] + 139,
            review[1],
            review[2]
        ],
        [
            output[0] - 115,
            output[1],
            output[2]
        ]
    ]));
    const target = (i)=>[
            review[0] + (i ? 59 : -59),
            review[1] - 12,
            review[2] - 5
        ];
    const destination = (i)=>[
            output[0] + (i ? 48 : -48),
            output[1] - 8,
            output[2] - 5
        ];
    const selected = cards.map((card)=>[
            ...card,
            $43853c709e3b11ec$var$line($43853c709e3b11ec$var$rect(-33, -27, 66, 54))
        ]);
    return {
        curves: curves,
        cloud: cloud,
        cloudCards: cloudCards,
        selected: selected,
        selections: selections,
        anchors: anchors,
        review: review,
        target: target,
        destination: destination
    };
}
function $43853c709e3b11ec$export$934973c2a4c5a085() {
    const models = [
        $43853c709e3b11ec$var$geometry(false),
        $43853c709e3b11ec$var$geometry(true)
    ];
    const sphere = [];
    for(let axis = 0; axis < 3; axis++){
        const points = [];
        for(let i = 0; i <= 48; i++){
            const a = i * Math.PI / 24, p = [
                Math.cos(a) * 58,
                Math.sin(a) * 58,
                0
            ];
            points.push(axis === 0 ? p : axis === 1 ? [
                p[0],
                0,
                p[1]
            ] : [
                0,
                p[0],
                p[1]
            ]);
        }
        sphere.push($43853c709e3b11ec$var$line(points));
    }
    const scan = [
        $43853c709e3b11ec$var$line([
            [
                -110,
                0,
                0
            ],
            [
                110,
                0,
                0
            ]
        ])
    ];
    const check = [
        $43853c709e3b11ec$var$line([
            [
                0,
                0,
                0
            ],
            [
                6,
                7,
                0
            ],
            [
                18,
                -9,
                0
            ]
        ])
    ];
    let previousKey, previous;
    return {
        labels: [],
        draw (seconds, small, reduced = false) {
            const time = reduced ? 0 : Math.floor(seconds * (small ? 24 : 30)) / (small ? 24 : 30);
            const key = `${time}/${small}/${reduced}`;
            if (key === previousKey) return previous;
            const model = models[+small], state = $43853c709e3b11ec$export$3d043a211b8a02eb(time, reduced);
            // Keep the camera fixed: depth comes from the cloud's rotation and the
            // pair moving from distant embeddings to the foreground review tray.
            const project = (0, $fkbDJ.projector)({
                time: 0,
                phase: 1.2,
                x: small ? 380 : 600,
                y: small ? 285 : 230,
                scale: small ? .94 : 1.04,
                depth: .8
            });
            let path = (0, $fkbDJ.renderCurves)(model.curves, project, 0, true);
            const drawAt = (curves, at, scale = 1)=>(0, $fkbDJ.renderCurves)(curves, (p)=>project(p.map((v, i)=>at[i] + v * scale)), 0, true);
            const cloudPoint = (point)=>$43853c709e3b11ec$export$2b4017880c7dba72(point, model.cloud, time, reduced);
            for (const { card: card, at: at, size: size } of model.cloudCards)path += drawAt(card, cloudPoint(at), size);
            const cycle = reduced ? 0 : Math.floor(time / 22) % model.anchors.length;
            const selection = model.selections[cycle];
            const searchProgress = reduced ? 1 : $43853c709e3b11ec$var$ease(state.phase / 3);
            const query = cloudPoint($43853c709e3b11ec$var$mix(model.anchors[(cycle + 3) % 4], model.anchors[cycle], searchProgress));
            // The search volume expands enough to include both retrieved neighbors.
            const previousRadius = Math.max(58, model.selections[(cycle + 3) % 4][1].distance + 8);
            const nextRadius = Math.max(58, selection[1].distance + 8);
            path += drawAt(sphere, query, (previousRadius + (nextRadius - previousRadius) * searchProgress) / 58);
            for(let i = 0; i < 2; i++){
                const at = $43853c709e3b11ec$export$57c2b080aa288d8c(selection[i].at, model.cloud, model.target(i), model.destination(i), time, reduced);
                const size = (.8 + .85 * state.gather - .6 * state.deliver) * state.presence;
                if (size > .01) path += drawAt(model.selected[selection[i].index % 2], at, size);
            }
            if (state.phase >= 3 && state.phase < 8 || reduced) for (const candidate of selection){
                const end = $43853c709e3b11ec$var$mix(query, cloudPoint(candidate.at), reduced ? 1 : $43853c709e3b11ec$var$ease(state.phase - 3));
                const a = project(query), b = project(end);
                path += `M${a[0].toFixed(1)},${a[1].toFixed(1)}L${b[0].toFixed(1)},${b[1].toFixed(1)}`;
            }
            if (state.review > 0) {
                const r = model.review;
                if (state.phase < 12) path += drawAt(scan, [
                    r[0],
                    r[1] - 60 + state.review * 96,
                    r[2] - 9
                ]);
                path += drawAt($43853c709e3b11ec$export$18f83102c9b9cfd(state.review), [
                    r[0],
                    r[1] + 65,
                    r[2] - 9
                ], 1.25);
                if (state.review === 1) path += drawAt(check, [
                    r[0] + 93,
                    r[1] - 64,
                    r[2] - 9
                ]);
            }
            previousKey = key;
            previous = {
                path: path,
                labels: []
            };
            return previous;
        }
    };
}


// Decorative, procedural illustrations; no video, external assets, or physics engine.
// Cache quantized frames so the shared lifecycle can pause and resume cheaply.
const $21e6e912c8ab293f$var$point = ([x, y, z], small)=>{
    const yaw = -0.13, pitch = .08;
    const xx = x * Math.cos(yaw) + z * Math.sin(yaw), zz = -x * Math.sin(yaw) + z * Math.cos(yaw);
    const yy = y * Math.cos(pitch) - zz * Math.sin(pitch), depth = y * Math.sin(pitch) + zz * Math.cos(pitch);
    const scale = (small ? .89 : 1.12) * 1600 / (1600 + depth);
    return [
        (small ? 380 : 600) + xx * scale,
        (small ? 300 : 230) + yy * scale
    ];
};
const $21e6e912c8ab293f$var$xy = (p)=>`${p[0].toFixed(1)},${p[1].toFixed(1)}`;
const $21e6e912c8ab293f$var$line = (points)=>points.map((p, i)=>(i ? 'L' : 'M') + $21e6e912c8ab293f$var$xy(p)).join('');
function $21e6e912c8ab293f$var$cachedScene(draw) {
    let previousKey, path;
    return {
        labels: [],
        draw (seconds, small, reduced = false) {
            const t = reduced ? 1.7 : Math.floor(seconds * (small ? 24 : 30)) / (small ? 24 : 30);
            const key = `${t}/${small}`;
            if (key !== previousKey) {
                path = draw(t, small);
                previousKey = key;
            }
            return {
                path: path,
                labels: []
            };
        }
    };
}
function $21e6e912c8ab293f$export$c9da12a1b5d83c67() {
    const layers = [
        {
            opacity: .11,
            strokeWidth: 2.3,
            overlap: false
        },
        {
            opacity: .16
        },
        {
            opacity: .28
        },
        {
            opacity: .43
        },
        {
            opacity: .62
        },
        {
            opacity: .8
        }
    ];
    const layouts = new Map(), delays = [
        0,
        .19,
        .42,
        .73,
        1.12,
        1.6
    ];
    let previousKey, previousFrame;
    function layout(small) {
        if (layouts.has(small)) return layouts.get(small);
        const cols = small ? 52 : 74, rows = small ? 36 : 26, spacing = small ? 13 : 14;
        const left = (small ? 380 : 600) - (cols - 1) * spacing / 2, top = (small ? 300 : 230) - (rows - 1) * spacing / 2;
        const dots = Array.from({
            length: cols * rows
        }, (_, i)=>'M' + $21e6e912c8ab293f$var$xy([
                left + i % cols * spacing,
                top + Math.floor(i / cols) * spacing
            ]) + 'l.05,0');
        const result = {
            cols: cols,
            rows: rows,
            dots: dots,
            grid: dots.join(''),
            masks: delays.map(()=>new Uint8Array(cols * rows))
        };
        layouts.set(small, result);
        return result;
    }
    function silhouette(mask, grid, t, small) {
        mask.fill(0);
        const { cols: cols, rows: rows } = grid, scale = small ? 1.25 : 1, count = small ? 2 : 3;
        const stamp = (x0, y0, x1, y1, inside)=>{
            for(let y = Math.max(0, Math.ceil(y0)); y <= Math.min(rows - 1, Math.floor(y1)); y++)for(let x = Math.max(0, Math.ceil(x0)); x <= Math.min(cols - 1, Math.floor(x1)); x++)if (inside(x, y)) mask[y * cols + x] = 1;
        };
        const ellipse = (x, y, rx, ry)=>stamp(x - rx, y - ry, x + rx, y + ry, (a, b)=>((a - x) / rx) ** 2 + ((b - y) / ry) ** 2 <= 1);
        const limb = (a, b, r)=>{
            const dx = b[0] - a[0], dy = b[1] - a[1], length = dx * dx + dy * dy;
            stamp(Math.min(a[0], b[0]) - r, Math.min(a[1], b[1]) - r, Math.max(a[0], b[0]) + r, Math.max(a[1], b[1]) + r, (x, y)=>{
                const f = Math.max(0, Math.min(1, ((x - a[0]) * dx + (y - a[1]) * dy) / (length || 1)));
                return (x - a[0] - f * dx) ** 2 + (y - a[1] - f * dy) ** 2 <= r * r;
            });
        };
        for(let person = 0; person < count; person++){
            const phase = t * .85 + person * 2.1, wave = Math.sin(phase), sway = Math.sin(t * .43 + person * 2.4) * 2.9;
            const origin = (small ? 14.5 + person * 23 : 13 + person * 23.5) + sway;
            const lift = .35 * Math.sin(phase * 1.7), lean = .7 * Math.sin(phase * .8);
            const p = (x, y)=>[
                    origin + x * scale,
                    (small ? 2 : 0) + (y + lift) * scale
                ];
            const head = p(lean, 5.4), chest = p(lean, 10.3), hips = p(0, 15);
            ellipse(...head, 1.55 * scale, 1.9 * scale);
            limb(p(lean, 7), chest, 1.15 * scale);
            ellipse(chest[0], (chest[1] + hips[1]) / 2, 2.65 * scale, 4.25 * scale);
            for (const side of [
                -1,
                1
            ]){
                const reach = Math.sin(phase + side * .9), shoulder = p(lean + side * 2.45, 9.3);
                const elbow = p(side * (5.5 + 1.2 * Math.cos(phase)), 8.5 + 3 * reach);
                const hand = p(side * (7.4 + 1.3 * Math.cos(phase * .7)), 5.9 + 4.4 * reach);
                limb(shoulder, elbow, 1.05 * scale);
                limb(elbow, hand, .85 * scale);
                ellipse(...hand, .95 * scale, 1.15 * scale);
                const knee = p(side * 2.1 + wave * .7, 19.7), foot = p(side * (3 + Math.max(0, side * wave) * 1.4), 24 - Math.max(0, side * wave) * 1.1);
                limb(p(side * 1.3, 15), knee, 1.25 * scale);
                limb(knee, foot, .95 * scale);
                limb(foot, [
                    foot[0] + side * 1.2 * scale,
                    foot[1]
                ], .8 * scale);
            }
        }
    }
    return {
        labels: [],
        layers: layers,
        draw (seconds, small, reduced = false) {
            const fps = small ? 20 : 24, t = reduced ? 1.7 : Math.floor(seconds * fps) / fps, key = `${t}/${small}`;
            if (key === previousKey) return previousFrame;
            const grid = layout(small), buckets = delays.map(()=>[]);
            delays.forEach((delay, i)=>silhouette(grid.masks[i], grid, t - delay, small));
            for(let i = 0; i < grid.dots.length; i++){
                // A lamp belongs to its newest exposure, avoiding stacked brightness.
                const exposure = grid.masks.findIndex((mask)=>mask[i]);
                if (exposure >= 0) buckets[exposure].push(grid.dots[i]);
            }
            previousKey = key;
            previousFrame = {
                path: buckets[0].join(''),
                labels: [],
                layers: [
                    grid.grid,
                    ...buckets.slice(1).reverse().map((dots)=>dots.join(''))
                ]
            };
            return previousFrame;
        }
    };
}
function $21e6e912c8ab293f$export$2aa24c9f3fc96dd6() {
    const nodes = [
        [
            -405,
            -115
        ],
        [
            -405,
            95
        ],
        [
            -190,
            -100
        ],
        [
            -190,
            115
        ],
        [
            40,
            -90
        ],
        [
            40,
            125
        ],
        [
            265,
            -110
        ],
        [
            265,
            105
        ],
        [
            430,
            0
        ]
    ];
    const edges = [
        [
            0,
            2
        ],
        [
            1,
            3
        ],
        [
            2,
            4
        ],
        [
            3,
            4
        ],
        [
            3,
            5
        ],
        [
            4,
            6
        ],
        [
            5,
            7
        ],
        [
            6,
            8
        ],
        [
            7,
            8
        ]
    ];
    return $21e6e912c8ab293f$var$cachedScene((t, small)=>{
        let path = '';
        const project = (p)=>$21e6e912c8ab293f$var$point(small ? [
                p[0] * .64,
                p[1] * 1.3,
                p[2]
            ] : p, small);
        const position = (i)=>[
                ...nodes[i],
                Math.sin(t * .35 + i * .7) * 20
            ];
        const dot = (p, r = 3)=>{
            const [x, y] = project(p);
            path += $21e6e912c8ab293f$var$line([
                [
                    x - r,
                    y
                ],
                [
                    x,
                    y - r
                ],
                [
                    x + r,
                    y
                ],
                [
                    x,
                    y + r
                ],
                [
                    x - r,
                    y
                ]
            ]);
        };
        nodes.forEach((_, i)=>{
            const [x, y, z] = position(i), w = 120, h = 104;
            const rect = (left, top, width, height, depth)=>$21e6e912c8ab293f$var$line([
                    [
                        left,
                        top,
                        depth
                    ],
                    [
                        left + width,
                        top,
                        depth
                    ],
                    [
                        left + width,
                        top + height,
                        depth
                    ],
                    [
                        left,
                        top + height,
                        depth
                    ],
                    [
                        left,
                        top,
                        depth
                    ]
                ].map(project));
            path += rect(x - w / 2, y - h / 2, w, h, z) + rect(x - w / 2, y - h / 2, w, h, z + 12);
            path += $21e6e912c8ab293f$var$line([
                [
                    x - w / 2,
                    y - 28,
                    z
                ],
                [
                    x + w / 2,
                    y - 28,
                    z
                ]
            ].map(project));
            for(let row = 0; row < 3; row++)path += rect(x - 39, y - 15 + row * 17, 78, 9, z);
            dot([
                x - w / 2,
                y - 33,
                z
            ], 4);
            dot([
                x + w / 2,
                y - 33,
                z
            ], 4);
        });
        for (const [index, [a, b]] of edges.entries()){
            const from = position(a), to = position(b);
            from[0] += 60;
            to[0] -= 60;
            from[1] -= 33;
            to[1] -= 33;
            const control1 = [
                from[0] + 60,
                from[1],
                from[2]
            ], control2 = [
                to[0] - 60,
                to[1],
                to[2]
            ];
            const curve = (f)=>from.map((v, i)=>(1 - f) ** 3 * v + 3 * (1 - f) ** 2 * f * control1[i] + 3 * (1 - f) * f * f * control2[i] + f ** 3 * to[i]);
            path += $21e6e912c8ab293f$var$line(Array.from({
                length: 19
            }, (_, i)=>project(curve(i / 18))));
            dot(curve((t * .16 + index * .13) % 1), 4);
        }
        return path;
    });
}


// Decorative chapter illustrations, not literal model architectures.
// Geometry is built once; the existing renderer caches shared vertices.
function $556ff8d20f3a1e41$var$plane(desktop, placement, mobile = desktop) {
    let previousKey, previousPath;
    return (camera, motion, small, reduced)=>{
        const key = `${camera}/${motion}/${small}/${reduced}`;
        if (key !== previousKey) {
            previousPath = (0, $fkbDJ.renderCurves)(small ? mobile : desktop, (0, $fkbDJ.projector)({
                time: camera,
                ...placement(small)
            }), motion, reduced);
            previousKey = key;
        }
        return previousPath;
    };
}
// Keep projection work bounded on phones; identical intermediate frames reuse
// the previous path, including the resting side of the alternating masthead.
const $556ff8d20f3a1e41$var$sceneTime = (seconds, small)=>Math.floor(seconds * (small ? 24 : 30)) / (small ? 24 : 30);
function $556ff8d20f3a1e41$export$b1c2be38fe671aa4() {
    const draw = $556ff8d20f3a1e41$var$plane((0, $8f62aaa2d023eb86$export$71e7376babd52330)().curves, (small)=>({
            phase: .8,
            x: small ? 380 : 625,
            y: small ? 252 : 242,
            scale: small ? .72 : .90,
            depth: .85
        }), (0, $8f62aaa2d023eb86$export$71e7376babd52330)(true).curves);
    return {
        labels: [],
        draw (seconds, small, reduced = false) {
            const time = $556ff8d20f3a1e41$var$sceneTime(seconds, small);
            return {
                path: draw(time * .21, time * .48, small, reduced),
                labels: []
            };
        }
    };
}
function $556ff8d20f3a1e41$export$22fdd080ef1c0640() {
    const arc = (0, $4d27c3991cee4fe1$export$f2438fc71952b444)();
    const iblt = $556ff8d20f3a1e41$var$plane((0, $1021d77fd48e7306$export$e3c49a7401c4be20)().curves, (small)=>({
            phase: .5,
            x: small ? 380 : 905,
            y: small ? 440 : 246,
            scale: small ? .66 : .59,
            depth: 1
        }));
    return {
        labels: [],
        draw (seconds, small, reduced = false) {
            // Start with ARC immediately, then alternate with IBLT.
            const clocks = (0, $ccb7e79fd3b726ea$export$57a8ab38cad627aa)($556ff8d20f3a1e41$var$sceneTime(seconds, small) + 13);
            return {
                path: arc.draw(clocks.arcCamera / .42, small, reduced).path + iblt(clocks.training, clocks.training, small, reduced),
                labels: []
            };
        }
    };
}


var $64bb08d2fc47dd6a$exports = {};
$64bb08d2fc47dd6a$exports = JSON.parse('[{"id":"krea-3","file":"resume-research.html","title":"Krea 3","rows":["Krea 3"],"caption":"Krea AI \xb7 Image editing","scene":"createEditingChapterScene","description":"Krea 3 image editing: editing-pair data pipelines, prompt expanders, training, and interactive examples."},{"id":"krea-2","file":"research-krea-2.html","title":"Krea 2","rows":["Krea 2"],"caption":"Krea AI \xb7 Text-to-image generation","scene":"createDitChapterScene","description":"Krea 2 text-to-image generation: training, concept coverage, and moodboards through prompt expansion."},{"id":"other-research","file":"research-other.html","title":"Other Research","rows":["Other","Research"],"caption":"Reasoning \xb7 Privacy \xb7 Personalization","scene":"createOtherResearchChapterScene","description":"Discrete diffusion for ARC, private federated learning on Gboard, and personalization and video stylization at Drip.art."},{"id":"just-for-fun","file":"work-just-for-fun.html","title":"Just for Fun","rows":["Just for","Fun"],"caption":"Interactive art \xb7 Hardware \xb7 Experiments","scene":"createDancingChapterScene","description":"Kinect the Dots, an interactive LED installation, and a handmade build-status widget."}]');



var $4ACxo = parcelRequire("4ACxo");
const $099d9e935759b59b$var$chapters = Object.fromEntries((0, (/*@__PURE__*/$parcel$interopDefault($64bb08d2fc47dd6a$exports))).map((chapter)=>[
        chapter.id,
        chapter
    ]));
// Only the illustration fades; the Lufga title keeps its solid silhouette.
// This is scoped to chapter SVGs and does not change the homepage renderer.
function $099d9e935759b59b$var$addChapterFade(hero, id) {
    const ns = 'http://www.w3.org/2000/svg';
    const element = (tag, attributes)=>{
        const node = document.createElementNS(ns, tag);
        for (const [key, value] of Object.entries(attributes))node.setAttribute(key, value);
        return node;
    };
    const svg = hero.querySelector('svg'), defs = svg.querySelector('defs');
    const gradient = element('linearGradient', {
        id: `${id}-depth-fade`,
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 1
    });
    for (const [offset, opacity] of [
        [
            0,
            .12
        ],
        [
            .08,
            .72
        ],
        [
            .18,
            1
        ],
        [
            .82,
            1
        ],
        [
            .94,
            .72
        ],
        [
            1,
            .12
        ]
    ])gradient.append(element('stop', {
        offset: offset,
        'stop-color': '#fff',
        'stop-opacity': opacity
    }));
    const mask = element('mask', {
        id: `${id}-depth-mask`,
        x: 0,
        y: 0,
        width: 1,
        height: 1,
        maskUnits: 'objectBoundingBox',
        maskContentUnits: 'objectBoundingBox',
        'mask-type': 'alpha'
    });
    mask.append(element('rect', {
        width: 1,
        height: 1,
        fill: `url(#${id}-depth-fade)`
    }));
    defs.append(gradient, mask);
    for (const path of svg.querySelectorAll('.research-hero-wires, .research-hero-overlap'))path.setAttribute('mask', `url(#${id}-depth-mask)`);
}
function $099d9e935759b59b$var$mountResearchHeaders() {
    const cleanup = [];
    const resume = document.querySelector('body.research-highlights .resume:not(.layout-comparison)');
    if (resume) for (const hero of resume.querySelectorAll('[data-chapter]')){
        const id = hero.dataset.chapter, chapter = $099d9e935759b59b$var$chapters[id];
        if (!chapter || hero.closest('[data-print-only]')) continue;
        const title = chapter.rows;
        const heading = resume.querySelector('.research-gallery-title');
        if (heading) heading.textContent = chapter.title;
        cleanup.push((0, $14e3b3396488c86f$export$5698593167017a47)(hero, {
            id: `${id}-hero`,
            caption: chapter.caption,
            centerTitle: true,
            titleRows: (small)=>(0, $4ACxo.workTitleRows)(title, small),
            viewBox: (small)=>small ? '0 0 760 600' : '0 0 1200 460',
            scene: $556ff8d20f3a1e41$exports[chapter.scene]()
        }));
        $099d9e935759b59b$var$addChapterFade(hero, `${id}-hero`);
    }
    return ()=>cleanup.forEach((dispose)=>dispose());
}
let $099d9e935759b59b$var$disposeHeaders = $099d9e935759b59b$var$mountResearchHeaders();
document.addEventListener("research:before-swap", ()=>$099d9e935759b59b$var$disposeHeaders());
document.addEventListener("research:after-swap", ()=>{
    $099d9e935759b59b$var$disposeHeaders = $099d9e935759b59b$var$mountResearchHeaders();
});


//# sourceMappingURL=resume-research.7f4cbc7f.js.map
